export default "__VITE_ASSET__BG33QkTO__"